import {AppConfig} from "@app/services/app.config";
import {SFTPAPIService} from "@app/services/sftp-api/sftp-api.service";
import {HttpStatusCode} from "@angular/common/http";
import {SFTPMainPages} from "@app/modules/models";

function checkConnection(sftpAPIService: SFTPAPIService): Promise<void> {
  return new Promise((resolve, reject) => {
    sftpAPIService.isConnected().subscribe({
      next: () => {
        resolve();
      },
      error: (error) => {
        if (error?.status === HttpStatusCode.Unauthorized) {
          if (!window.location.pathname.startsWith(`/${SFTPMainPages.login}`)) {
            window.location.replace(`/${SFTPMainPages.login}`);
          } else {
            resolve();
          }
        } else {
          reject(error);
        }
      },
    });
  });
}

export function initializeApp(appConfig: AppConfig, sftpAPIService: SFTPAPIService): () => Promise<void> {
  return async (): Promise<void> => {
    await appConfig.load();
    await checkConnection(sftpAPIService);
  };
}
